import React, { useState } from 'react';

const Booking: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    reason: '',
    date: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically handle form submission, e.g., send to an API
    console.log('Form data submitted:', formData);
    setIsSubmitted(true);
    setFormData({ name: '', email: '', phone: '', reason: '', date: '' });
    setTimeout(() => setIsSubmitted(false), 5000); // Reset after 5 seconds
  };
  
  const whatsappNumber = "1234567890"; // Reemplazar con número real
  const whatsappMessage = "Hola, quiero agendar una cita.";

  return (
    <section id="booking" className="py-20 bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="lg:flex lg:items-center lg:gap-12">
          <div className="lg:w-1/2">
            <h2 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white">Agenda tu Cita Online</h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 mt-4 mb-8">
              Completa el formulario para solicitar tu cita. Nuestro equipo te contactará a la brevedad para confirmar.
            </p>
            <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-lg">
              {isSubmitted ? (
                <div className="text-center p-8 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded-lg">
                    <h3 className="font-bold text-xl">¡Gracias!</h3>
                    <p>Tu solicitud de cita ha sido registrada. Te contactaremos pronto.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <InputField label="Nombre Completo" name="name" type="text" value={formData.name} onChange={handleChange} required />
                  <InputField label="Correo Electrónico" name="email" type="email" value={formData.email} onChange={handleChange} required />
                  <InputField label="Teléfono" name="phone" type="tel" value={formData.phone} onChange={handleChange} />
                  <TextAreaField label="Motivo de la consulta" name="reason" value={formData.reason} onChange={handleChange} />
                  <InputField label="Fecha Preferida" name="date" type="date" value={formData.date} onChange={handleChange} />
                  <button 
                    type="submit" 
                    name="Enviar Solicitud" 
                    id="Enviar Solicitud" 
                    aria-label="Enviar Solicitud"
                    className="w-full bg-primary text-white py-3 px-6 rounded-xl font-bold text-lg hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105">
                    Enviar Solicitud
                  </button>
                </form>
              )}
            </div>
          </div>
          <div className="lg:w-1/2 mt-12 lg:mt-0 text-center">
             <img 
              aria-label="Doctor sonriendo a un paciente"
              name="Doctor sonriendo a un paciente"
              id="Doctor sonriendo a un paciente"
              width="500"
              height="500"
              src="https://i.ibb.co/hxD42mnn/pexels-karolina-grabowska-7195310.jpg" alt="Doctor sonriendo a un paciente" className="rounded-lg shadow-xl mx-auto"/>
             <p className="mt-8 text-lg text-gray-700 dark:text-gray-300">¿Prefieres un contacto más directo?</p>
             <a 
                href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`} 
                target="_blank" 
                rel="noopener noreferrer" 
                name="Chatea por WhatsApp"
                id="Chatea por WhatsApp"
                aria-label="Chatea por WhatsApp"
                className="inline-block mt-4 bg-green-500 text-white py-3 px-8 rounded-xl font-bold text-lg hover:bg-green-600 transition-all duration-300 transform hover:scale-105">
                Chatea por WhatsApp
             </a>
          </div>
        </div>
      </div>
    </section>
  );
};

// Helper component for form fields
interface InputFieldProps {
  label: string;
  name: string;
  type: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
}

const InputField: React.FC<InputFieldProps> = ({ label, name, type, value, onChange, required }) => (
  <div>
    <label htmlFor={name} className="block text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>
    <input
      type={type}
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      className="mt-1 block w-full px-4 py-2 bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm focus:ring-primary focus:border-primary sm:text-sm"
    />
  </div>
);

interface TextAreaFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const TextAreaField: React.FC<TextAreaFieldProps> = ({ label, name, value, onChange }) => (
    <div>
      <label htmlFor={name} className="block text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        rows={4}
        className="mt-1 block w-full px-4 py-2 bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-xl shadow-sm focus:ring-primary focus:border-primary sm:text-sm"
      ></textarea>
    </div>
);


export default Booking;